import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Route, Switch } from 'react-router-dom';
import * as RX from 'reactxp';

import { mapStateToProps } from '../../utils/mapper';

import Footer from '../../components/footer';
import Menu from '../../components/menu';
import MenuDropdown from '../../components/menu/menu_dropdown';
import WrappedRoutes from '../../components/wrapper_routes';

import { md } from '../../utils/breakpoints';

interface RouterWrapperProps {
  routes: { notWrappedRoutes: any[], wrappedRoutes: any[] };
  menuItems: any;
  window: { width: number, height: number, menuHeight: number };
  location: any;
  menu: any;
  popup: { show: boolean };
};

class RouterWrapper extends React.Component<RouterWrapperProps> {
  constructor(props: RouterWrapperProps) {
    super(props);
  }

  public componentDidUpdate(prevProps: any) {
    if (this.props.location !== prevProps.location) {
      const { window: { menuHeight }, menu: { toggle }} = this.props;
      menuHeight > 0 && toggle(); //tslint:disable-line
    }

    if (this.props.popup.show) {
      const el = document.getElementsByTagName('body')[0]
      el.style.overflow = 'hidden';

    } else if (!this.props.popup.show) {
      const el = document.getElementsByTagName('body')[0]
      el.style.overflow = 'inherit';
    }
  }

  public render() {
    const { window: { width, height, menuHeight }, routes } = this.props;

    return (
      <RX.ScrollView style={{ minHeight: height }}> {/*tslint:disable-line*/}
        <Menu menuItems={this.props.menuItems} />
        {(width >= md || menuHeight === 0) && <Switch>
          {routes.notWrappedRoutes.map(({ path, component, exact = false }) =>
            <Route key={path} {... { path, component, exact }} />)}
          <WrappedRoutes>
            {routes.wrappedRoutes.map(({ path, component, exact = false }) =>
              <Route key={path} {... { path, component, exact }} />)}
          </WrappedRoutes>
        </Switch>}
        {(width >= md || menuHeight === 0) && <Footer />}
        <MenuDropdown />
      </RX.ScrollView>
    );

  }
}

export default withRouter(connect(mapStateToProps)(RouterWrapper));



// WEBPACK FOOTER //
// ./src/modules/routing/web_wrapper.tsx